/**
 * Component to show the listing information for sub organizations
 */
import * as React from 'react';
import { Table } from 'antd';
import { IcommonProps } from '../common/props';
import '../../css/OrganizationList.scss';
import { Link } from 'react-router-dom';
import strings from '../../eyeguide-localization/organization/strings.organization';
import { CustomSorter } from '../Sorter';
/**
 * Property definition 
 */
interface IOrganizationListProps extends IcommonProps {
    orgs: Array<any>;
    notifyActiveClick: any;
    loading: boolean;
    emptyText: string;
    isCustomer: boolean;
}

/**
 * State definition
 */
interface IOrganizationListState {
    columnData: Array<any>;
    columns: Array<any>;
    pagination: any;
    loading: boolean;
    selectedRowKeys: Array<string>;    
    childColumnNames: any;
    emptyText: string;
    isCustomer: boolean;
}

/**
 * Listing component for displaying the organization
 */
export default class OrganizationList extends React.Component<IOrganizationListProps, IOrganizationListState> {

    rowClass: string = 'rows';

    constructor(props: IOrganizationListProps) {
        super(props);
        this.state = {
            columnData: [],
            columns: [],
            pagination: {},
            loading: true,
            selectedRowKeys: [],
            childColumnNames: ['name', 'value'],
            emptyText: '',
            isCustomer: true
        };        
    }

    componentDidMount() {
        strings.setLanguage(navigator.language);
        this.componentWillReceiveProps(this.props);

    }

    componentWillReceiveProps(nextProps: any) {
        console.log('componentWillReceiveProps', nextProps);
        let columnData: any = [];
        if (nextProps.orgs !== undefined && nextProps.orgs.length > 0) {
             this.buildData(nextProps.orgs);
        }
        columnData = this.buildData(nextProps.orgs);
        let columns = this.buildColumns(nextProps);
        const pagination = { ...this.state.pagination };
        pagination.total = nextProps.orgs.length;
        pagination.pageSize = 20 ;
        pagination.pageSizeOptions = ['20', '50', '75', '100'];
        pagination.showSizeChanger = true ;  
        pagination.showTotal = function (total: any) {
            return strings.formatString(strings.lsTotalOrgTxt, total);
        };
        this.setState({
            loading: nextProps.loading,
            columnData: columnData,
            columns: columns,
            pagination,
            emptyText: nextProps.emptyText,
            isCustomer: nextProps.isCustomer
        });
    }

    render() {
        console.log('OrgList render called');
        return (           
            <Table 
                className="OrganizationList"
                columns={this.state.columns} 
                dataSource={this.state.columnData} 
                pagination={this.state.pagination}
                rowKey={record => record.organizationid}
                loading={this.state.loading}
                rowClassName={(record, index) => 'rows'}
                expandRowByClick={true}
                locale={{ emptyText: this.state.emptyText }} 
            />        
        );            
    }

    /**
     * This function builds the data required by the Table component to display the Organizations
     * @param orgs Organization array containing the Organizations to be dispalyed
     */
    private buildData(orgs: Array<any>) {
        let columnData: Array<any> = [];
        orgs.forEach( (element: any) => {
            let data = {
                organizationid: element.organizationid,
                name: element.name,
                contactfirstname: element.contactfirstname,
                contactlastname: element.contactlastname,
                contactphone: element.contactphone,
                contactemail: element.contactemail,
                profiles: element.totalAthletes,
                tests: element.totalTests,
                baselines: element.totalBaselines,
                address: element.address ,
                email: element.email,
                website: element.website,
                active: element.active,
                isprimary: element.isprimary
            };
            columnData.push(data);
        }); 
        return columnData;
    }
  
    /**
     * This function returns the column setting for use with the Table component
     */
    private buildColumns(nextProps: any) {
        let columns = [
          {
            title: strings.lsNameTxt,
            dataIndex: 'name',
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
            className: 'rows',
            render: (text: any, record: any) => (
                <div
                    className={'clipped'}
                    style={{width: '140px'}}
                    title={text}
                >
                    {record.isprimary === true ?
                    <span style={{color: '#2e59a0', fontSize: '15px', fontWeight: 900}}> 
                        * 
                    </span> : ''}
                    {text}
                </div>
            ),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: this.state.isCustomer ? 'Profiles' : 'Contact first name',
            dataIndex: this.state.isCustomer ? 'profiles' : 'contactfirstname',
            sorter: (a: any, b: any) => {
                return this.state.isCustomer
                    ? (a.totalAthletes - b.totalAthletes)
                    : (a.contactfirstname.localeCompare(b.contactfirstname));
            },
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '150px'}}
                    title={text}
                >
                    {text}
                </div>
            ),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: this.state.isCustomer ? 'Tests' : 'Contact last name',
            dataIndex: this.state.isCustomer ? 'tests' : 'contactlastname',
            sorter: (a: any, b: any) => {
                return this.state.isCustomer
                    ? (a.totalTests - b.totalTests)
                    : (a.contactlastname.localeCompare(b.contactlastname));
            },
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '150px'}}
                    title={text}
                >
                    {text}
                </div>
            ),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: this.state.isCustomer ? 'Baselines' : 'Contact phone',
            dataIndex: this.state.isCustomer ? 'baselines' : 'contactphone',
            sorter: (a: any, b: any) => {
                return this.state.isCustomer
                    ? (a.totalBaselines - b.totalBaselines)
                    : (a.contactphone.localeCompare(b.contactphone));
            },
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '125px'}}
                    title={text}
                >
                    {text}
                </div>
            ),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: strings.lsAction,
            dataIndex: 'organizationid',            
            render: (text: any, record: any) => (
                <div>
                    {this.state.isCustomer ? '' :
                    <Link 
                        // className="linkSpacing"
                        to={'/organization/edit/' + record.organizationid}
                    >{!record.isprimary ? strings.lsEditTxt + ' | ' : strings.lsEditTxt}
                    </Link>
                    }
                    {record.isprimary || this.state.isCustomer ? '' : <a 
                        onClick={(e) => {    
                            console.log('record in onclick', record);  
                            console.log('e', e);
                            console.log('text', text);
                            e.stopPropagation();               
                            this.props.notifyActiveClick(record.active === 0 ? 1 : 0, record.organizationid, record);
                        }}
                    >{record.active === 0 ? strings.lsActivateTxt : strings.lsDeactivateTxt}
                    </a>}
                    {this.state.isCustomer ? 
                        <Link 
                            className="linkSpacing"
                            to={{
                                pathname: `/organization/view/${JSON.stringify(record)}`,
                                state: record
                            }}
                        > {strings.lsView}
                        </Link>

                    : ''}
                </div>
            ),
          }
        ];

        if (!this.state.isCustomer) {
            columns.splice(
                4,
                0,
                {
                    title: 'Contact email',
                    dataIndex: 'contactemail',
                    sorter: (a: any, b: any) => a.contactemail.localeCompare(b.contactemail),
                    className: 'rows',
                    render: (text: any) => (
                        <div
                            className={'clipped'}
                            style={{width: '125px'}}
                            title={text}
                        >
                            {text}
                        </div>
                    ),
                    onHeaderCell: (column) => {
                        return {
                            onClick: () => {
                                this.setState({
                                    columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                                });
                            }
                        };
                    }
                }
            );
        }
        return columns;
    }
    
}


// WEBPACK FOOTER //
// ./src/components/organization/OrganizationList.tsx